export default __webpack_public_path__ + "static/media/auth.02b94c1d.png";